import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CookieIframe',
  data: function data() {
    return {
      cookies: this.$cookies
    };
  },
  computed: {
    iframeEnabled: function iframeEnabled() {
      return this.cookies.enabled.filter(function (c) {
        return c.name === 'functional';
      }).length > 0;
    },
    iframeText: function iframeText() {
      return this.cookies && this.cookies.text ? this.cookies.text.blockedIframe : '';
    }
  }
};